import api from './api'
import { BASE } from './config'

import { DEFAULT_PAGINATION_LIMIT } from '../constants/common'

class AgenciesService {
  getAgenciesList({ params, cancelToken }) {
    return api.get(`${BASE}/health_agencies/`, {
      params: { ...params, limit: DEFAULT_PAGINATION_LIMIT },
      cancelToken,
    })
  }

  getAgencyDetails({ uuid }) {
    return api.get(`${BASE}/health_agencies/${uuid}/`)
  }

  updateAgencyDetails({ uuid, data }) {
    return api.patch(`${BASE}/health_agencies/${uuid}/`, data)
  }

  getAgencyUsersList({ uuid }) {
    return api.get(`${BASE}/health_agencies/${uuid}/users/`)
  }

  getAgenciesFilterOptions() {
    return api.get(`${BASE}/health_agencies/filter_list/`).then((resp) => {
      return resp.data.map((ag) => ({
        ...ag,
        value: ag.uuid,
        label: ag.name,
        id: ag.uuid,
      }))
    })
  }
}

export default new AgenciesService()
